import { Children, ReactNode } from 'react';
import { Hero } from '../Hero/Hero';
import './Banner.scss';
import { OEMType as EOEMType } from '../../types';
// EOEMType = enum oemType

const IMAGE_PLACEHOLDER = 'Hero Image';

interface BannerProps {
  children?: ReactNode;
  defaultImage?: string | undefined;
  defaultImageLabel?: string | undefined;
  defaultImageAlt?: string | undefined;
  alternatetImage?: string | undefined;
  alternatetImageLabel?: string | undefined;
  alternatetImageAlt?: string | undefined;
  alternate?: boolean;
  OEMType?: EOEMType;
}

const Banner = ({
  children,
  defaultImage = IMAGE_PLACEHOLDER,
  defaultImageLabel = IMAGE_PLACEHOLDER,
  defaultImageAlt = IMAGE_PLACEHOLDER,
  alternatetImage = IMAGE_PLACEHOLDER,
  alternatetImageLabel = IMAGE_PLACEHOLDER,
  alternatetImageAlt = IMAGE_PLACEHOLDER,
  alternate = false,
  OEMType = EOEMType.Brunswick,
}: BannerProps) => {
  // this will need to be some sort of call to get the theme colour
  const currentThemePrimary = '#f56400';

  // primary: 245, 100, 0
  // jaffa: 247, 139, 64
  // hot-pink: 250, 177, 128

  const convertColour = (hex: string, red: number, green: number, blue: number) => {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.min(r + red, 255);
    g = Math.min(g + green, 255);
    b = Math.min(b + blue, 255);

    return `rgb(${r}, ${g}, ${b})`;
  };

  const jaffa = convertColour(currentThemePrimary, 2, 39, 64);
  const hotPink = convertColour(currentThemePrimary, 5, 77, 128);

  return (
    <div className="banner-container" role="banner">
      {!alternate && (
        <>
          <Hero>
            {OEMType === EOEMType.Brunswick ? (
              <img src={defaultImage} alt={defaultImageAlt} aria-label={defaultImageLabel} />
            ) : (
              <img src={alternatetImage} alt={alternatetImageAlt} aria-label={alternatetImageLabel} />
            )}
          </Hero>
          <div className="hot-pink" style={{ backgroundColor: hotPink }}></div>
          <div className="jaffa" style={{ backgroundColor: jaffa }}></div>
        </>
      )}
      <div
        className={`banner-wrapper ${alternate ? 'alternate' : ''}`}
        style={{ backgroundColor: currentThemePrimary }}>
        {children && Children.toArray(children).length > 0 && (
          <div className={alternate ? 'alternate' : ''}>{children}</div>
        )}
      </div>
    </div>
  );
};

export default Banner;
